module.exports = __webpack_public_path__ + "img/pulled_pork_done_whole.253ef2f4.jpg";